// extracted by mini-css-extract-plugin
module.exports = {"carousel":"Banner_carousel__1Lrbp","btn":"Banner_btn__kruup","bannerImg":"Banner_bannerImg__3iXoj"};